import { fetchUtils } from 'react-admin';

const { REACT_APP_PROXI } = process.env;

const authHeaders = () => {
    const headers = new Headers({
        Accept: 'application/json',
        'Content-Type': 'application/json',
    });
    const token = localStorage.getItem('token');
    if (token) {
        headers.set('Authorization', `Bearer ${token}`);
    }
    return headers;
};

/**
 * Thin POST helper for the supply action endpoints
 * (adjust, hold, consume, finalize, sublot open/close).
 * These are not CRUD, so they sit outside the react-admin dataProvider.
 */
const supplyPost = (path, body) => {
    const options = {
        method: 'POST',
        body: JSON.stringify(body || {}),
        headers: authHeaders(),
    };

    return fetchUtils.fetchJson(`${REACT_APP_PROXI}/${path}`, options).then(({ json }) => json);
};

/**
 * Authenticated GET for endpoints that are not react-admin resources -
 * /supplyconsumption/:refType/:refId, /donorincident/:process_id.
 */
export const apiGet = (path) =>
    fetchUtils
        .fetchJson(`${REACT_APP_PROXI}/${path}`, { method: 'GET', headers: authHeaders() })
        .then(({ json }) => json);

/** Original name, kept so the soft goods loader does not have to change. */
export const supplyGet = apiGet;

export default supplyPost;
